import SolidButton from '@/components/Common/Button/SolidButton'
import { useTranslation } from 'react-i18next'

const ApplicationClosed = ({ isKtpDomain = false }: { isKtpDomain?: boolean }) => {
  const { t } = useTranslation('common')
  return (
    <>
      <div className="flex items-center justify-center">
        <p
          className={`text-sm font-semibold lg:text-lg ${isKtpDomain ? 'text-[#424242]' : 'text-normal'}`}>
          {isKtpDomain ? '이번 프로그램 모집은 마감되었습니다.' : t('cta.closed.message')}
        </p>
      </div>
      <div className="w-full lg:max-w-[160px]">
        <SolidButton
          className={`!h-10 !w-full lg:!h-11 ${isKtpDomain ? '!bg-[#B8B8B8] !text-[#787878]' : ''}`}
          disabled={true}>
          {isKtpDomain ? '모집 마감' : t('cta.closed.button')}
        </SolidButton>
      </div>
    </>
  )
}

export default ApplicationClosed
